import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  useTheme,
} from '@mui/material';

const ActiveConfirmDialog = ({ open, handleClose, handleConfirm, message }) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{"Confirmation"}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} sx={{ color: theme.palette.error.main }}>
          Cancel
        </Button>
        <Button onClick={handleConfirm} sx={{ color: theme.palette.success.main }} autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActiveConfirmDialog;